import { render, staticRenderFns } from "./ComplaintsVguard2.vue?vue&type=template&id=d7eaf7f6&scoped=true"
import script from "./ComplaintsVguard2.vue?vue&type=script&lang=js"
export * from "./ComplaintsVguard2.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsVguard2.vue?vue&type=style&index=0&id=d7eaf7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7eaf7f6",
  null
  
)

export default component.exports